import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  SET_USER_TO_BE_CREATED,
  SET_CAMPAIGNS_TO_BE_CREATED,
  CREATE_REGISTRATION_PENDING_USER,
  CREATE_REGISTRATION_PENDING_USER_SUCCESS,
  CREATE_REGISTRATION_PENDING_USER_FAILURE,
  GET_REGISTRATION_PENDING_USER_BY_ID,
  GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS,
  GET_REGISTRATION_PENDING_USER_BY_ID_ERROR
} from "./actionTypes"

const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  set_user_to_be_created: null,
  campaigns_to_be_created: [],
  registration_pending_user: null,
  registration_pending_user_loading: false,
  registration_pending_user_error: null
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMPAIGNS_TO_BE_CREATED:
      state = {
        ...state,
        loading: false,
        campaigns_to_be_created: [...state.campaigns_to_be_created, action.payload.campaign],
        registrationError: null,
      }
      break
    case SET_USER_TO_BE_CREATED:
      state = {
        ...state,
        loading: false,
        set_user_to_be_created: action.payload.user,
        registrationError: null,
      }
      break
    case REGISTER_USER:
      state = {
        ...state,
        loading: true,
        registrationError: null,
      }
      break
    case REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        registrationError: null,
        set_user_to_be_created: null,
      }
      break
    case REGISTER_USER_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
      }
      break
    case CREATE_REGISTRATION_PENDING_USER:
      state = {
        ...state,
        registration_pending_user_loading: true
      }
      break
    case CREATE_REGISTRATION_PENDING_USER_SUCCESS:
      state = {
        ...state,
        registration_pending_user: action.payload,
        registration_pending_user_loading: false
      }
      break
    case CREATE_REGISTRATION_PENDING_USER_FAILURE:
      state = {
        ...state,
        registration_pending_user_error: action.payload,
        registration_pending_user_loading: false
      }
      break
    case GET_REGISTRATION_PENDING_USER_BY_ID:
      state = {
        ...state,
        registration_pending_user_loading: true
      }
      break
    case GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS:
      state = {
        ...state,
        registration_pending_user: action.payload,
        registration_pending_user_loading: false
      }
      break
    case GET_REGISTRATION_PENDING_USER_BY_ID_ERROR:
      state = {
        ...state,
        registration_pending_user_error: action.payload,
        registration_pending_user_loading: false
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
